import { insertMessageToDOM } from "../Chat";
import { DeleteRun, RemovePlayerFromRun, AddPlayerToRun } from "../Firebase";
import { UserContext } from '../../Context/Context'
import { useContext, useEffect } from 'react'
import { useLocation } from "react-router";
import { isReady, peerJoined, readyUpDom, setPeerReady} from "../RunCard";
import * as online from "../Game/MultiplayerGame";
import { PushHistory } from "../Game/Load"

let runHash, runId;
let pc;
let dataChannel;
let ScaleDrone = window.ScaleDrone;
let drone = null;
let globalIsGuest = null;
let currentUser = null;
let gameStarted = false
let LOCATION;
const Rtc = () => {
  const {user, setUser} = useContext(UserContext)
  currentUser = user
  const location = useLocation();
  LOCATION = location 
  runId = location.state.Run.id
  useEffect(() => {
    return () => { 
      CloseConnection(location.state.Run.id); 
      RemovePlayerFromRun(location.state.Run.id);
    }
  }, [])
  return (
    <div style={{display:'none'}}></div>
  )
}

export default Rtc

export function StartPeerConnection(isGuest) {
   if (!window.location.hash || window.location.hash == null) {
      window.location.hash = Math.floor(Math.random() * 0xFFFFFF).toString(16);
  }
  runHash = window.location.hash.substring(1);

  drone = new ScaleDrone('oRop4xcN5B5d2z12');

  const roomName = 'observable-' + runHash;
  let room;

  const configuration = {
    iceServers: [{
      url: 'stun:stun.l.google.com:19302'
    }]
  };

  let members = []

  drone.on('open', error => {
    if (error) {
      return console.error(error);
    }
    room = drone.subscribe(roomName);
    room.on('open', error => {
      if (error) {
        return console.error(error);
      }
    });

    room.on('members', mem => {
      members = mem;
      if (members.length >= 3){
        return alert('The room is full');
      }
      else if (members.length === 1 && isGuest === true){
        window.location.hash = null;
        return alert('Room does not exist')
      }
     
      if (window.location.pathname === '/lobby'){
        isGuest = members.length === 2;
      }
      globalIsGuest = isGuest 
      startWebRTC(isGuest);  
    });

    room.on('member_leave', ({id}) => {
      const index = members.findIndex(member => member.id === id);
      members.splice(index, 1)
    })
  });

  function sendSignalingMessage(message) {
    drone.publish({
      room: roomName,
      message
    });
  }

  function startWebRTC(isGuest){
    pc = new RTCPeerConnection(configuration)
     pc.onicecandidate = event => {
      if (event.candidate) {
        sendSignalingMessage({'candidate': event.candidate});
      }
    };

    if (isGuest) {
        pc.onnegotiationneeded = () => {
        pc.createOffer(localDescCreated, error => console.error(error));
        }
        dataChannel = pc.createDataChannel('chat');
        setupDataChannel();
    } else {
      pc.ondatachannel = event => {
        dataChannel = event.channel;
        setupDataChannel();
      }
    }
    startListentingToSignals();
  } 
  
  function setupDataChannel() {
    checkDataChannelState();
    dataChannel.onopen = checkDataChannelState;
    dataChannel.onclose = checkDataChannelState;
    dataChannel.onclosing = checkDataChannelState;
    dataChannel.onmessage = event => {
      var Obj = JSON.parse(event.data);
      switch (Obj["type"]){
        case "joined": {
          peerJoined(JSON.parse(event.data))
        }
        case "chat":
          if (Obj.content != null){
            insertMessageToDOM(JSON.parse(event.data), false)
          }
          break;
        case "ready":
          var PeerReady = Obj["Ready"]
          readyUpDom(JSON.parse(event.data), false)
          setPeerReady(PeerReady)
          StartGame(isReady , PeerReady)
        break;
        case "jump press":
          online.PlayerJump2(true)
          break;
        case "jump release":
          online.PlayerJump2(false)
          break;
        case "right press":
          online.Player2RightInput(true)
          break;
        case "right release":
          online.Player2RightInput(false)
          break;
        case "left press":
          online.Player2LeftInput(true)
          break;
        case "left release":
          online.Player2LeftInput(false)
          break;
        case "GameStart":
          PushHistory('/online')
          online.GameStart();
          break;
        case "platform":
          if (Obj.platform === 1){
            online.RespawnGround1(Obj)
          }
          if (Obj.platform === 2){
            online.RespawnGround2(Obj)
          }
          if (Obj.platform === 3){
            online.RespawnGround3(Obj)
          }
        break;
        case "restart":
          online.setP2RestartReady()
          break;
        case "setGameMode":
          document.querySelector('.toggle').checked = Obj.isChecked
          localStorage.setItem('VersusGameMode', Obj.isChecked)
        default:
          break;
      }
    }
  }

  function checkDataChannelState() {
    if (dataChannel.readyState === 'open') {
      if (isGuest && window.location.pathname === '/lobby'){
        const joinData = {
          type: 'joined',
          user: currentUser.displayName
        }
        dataChannel.send(JSON.stringify(joinData))
        const data = {
          type:"chat",
          name:"",
          content: `${currentUser.displayName} has joined the run !`,
          picture: currentUser.photoURL
        }
        dataChannel.send(JSON.stringify(data))
        insertMessageToDOM({name: "", content: 'You joined the Run !', picture:currentUser.photoURL}, true)
        peerJoined({user: LOCATION.state.Run.player})
        AddPlayerToRun(runId)
      }
      localStorage.setItem('IsGuest', isGuest)
      if (window.location.pathname === '/load' && localStorage.getItem('IsGuest') === "true"){
        if (!gameStarted){
          PushHistory('/online')
          SendGameStart();
          online.GameStart()
          gameStarted = true
        }
      }
    }
    else if (dataChannel.readyState === 'closed') {
      dataChannel.close()
      startWebRTC(globalIsGuest)
    }
    else if (dataChannel.readyState === 'closing') {}
  }

  function startListentingToSignals() {
    room.on('data', (message, client) => {
      if (client.id === drone.clientId) {
        return;
      }
      if (message.sdp) {
        pc.setRemoteDescription(new RTCSessionDescription(message.sdp), () => {
          if (pc.remoteDescription.type === 'offer') {
            pc.createAnswer(localDescCreated, error => console.error(error));
          }
        }, error => console.error(error));
      } else if (message.candidate) {
        pc.addIceCandidate(new RTCIceCandidate(message.candidate));
      }
    });
  }
  function localDescCreated(desc) {
    pc.setLocalDescription(
      desc,
      () => sendSignalingMessage({'sdp': pc.localDescription}),
      error => console.error(error)
    );
  }

  function SendGameStart() {
    const data = {
      type: 'GameStart'
    }
    dataChannel.send(JSON.stringify(data))
  }
  
}



export function CloseConnection(id){
  if (window.location.pathname === '/lobby'){
    const data = {
      type: "chat",
      name: "",
      content: `${currentUser.displayName} has left te run !`,
      picture: currentUser.photoURL
    }
  
    sendDataChannel(data)
  }
  if (globalIsGuest === false){
    DeleteRun(id)  
  }
  if (pc) pc.close();
  drone.close();
}

export function sendDataChannel(data){
  if (dataChannel) {
   if (dataChannel.readyState === "open") dataChannel.send(JSON.stringify(data));
  }
}

export function ReadyUp(Ready, FromMe){
  const data = {
    type: 'ready',
    Ready: Ready
  }
  dataChannel.send(JSON.stringify(data))
}

export function StartGame(isP1Ready, isP2Ready){
  if (isP1Ready === true && isP2Ready === true){
    LOCATION.state.Run.id = LOCATION.state.Run.id + 'z'  
    window.location.hash = LOCATION.state.Run.id;
    CloseConnection(runId);
   window.location.pathname = '/load'
  }
}

export function SendAction(type) {
  const data = {
    type: type
  }
  dataChannel.send(JSON.stringify(data))
}

export {globalIsGuest}